import { getCookie, setCookie } from "./helpers";
import {
  CancellationServiceState,
  CancellationServiceTypes,
  CancellationServiceAction,
} from "./types";

const initialState: CancellationServiceState = {
  purchaseDetails: {
    invoice: "",
    date_of_purchase: "",
    store_name: "",
    store_phone: "",
    store_address: "",
    store_city: "",
    store_state: "",
    were_any_items_exchanged: "",
    store_zip: "",
  },
  customerDetails: {
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
  },
  documents: {
    invoice: [],
  },
  cancellation_reason: "",
  ...JSON.parse(getCookie("cancellation_data") || "{}"),
};

export const cancellationServiceReducer = (
  state: CancellationServiceState = initialState,
  action: CancellationServiceTypes
): CancellationServiceState => {
  switch (action.type) {
    case CancellationServiceAction.UPDATE_STATE: {
      const mappedState = Object.keys(action?.payload || {}).reduce(
        (acc, key) => {
          acc[key] = action.payload[key];
          return acc;
        },
        {}
      );
      setCookie(
        "cancellation_data",
        { ...state, ...mappedState },
        { parseJson: true }
      );
      return { ...state, ...mappedState };
    }

    case CancellationServiceAction.CLEAN_UP: {
      return {
        purchaseDetails: {
          invoice: "",
          date_of_purchase: "",
          store_name: "",
          store_phone: "",
          store_address: "",
          store_city: "",
          store_state: "",
          were_any_items_exchanged: "",
          store_zip: "",
        },
        customerDetails: {
          name: "",
          email: "",
          phone: "",
          address: "",
          city: "",
          state: "",
          zip_code: "",
        },
        documents: {
          invoice: [],
        },
        cancellation_reason: "",
      };
    }

    default:
      return state;
  }
};
